import { HeadingSection } from 'bold-ui'
import { Form, FormProps, FormRenderProps, FormValueSpy, TextAreaField } from 'components/form'
import { CiapSelectField, CiapSelectFieldModel } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import React from 'react'
import { metaPath } from 'util/metaPath'

export interface MotivoConsultaFormModel {
  texto: string
  ciap: CiapSelectFieldModel
}

export const meta = metaPath<MotivoConsultaFormModel>()

export interface MotivoConsultaFormProps extends FormProps<MotivoConsultaFormModel> {}

export function MotivoConsultaForm(props: MotivoConsultaFormProps) {
  const renderForm = (formProps: FormRenderProps<MotivoConsultaFormModel>) => {
    return (
      <>
        <FormValueSpy onChange={formProps.form.submit} />

        <HeadingSection level={3} title='Motivo da consulta'>
          <CiapSelectField name={meta.ciap} label='CIAP 2' excluirCIAPsDAB={true} />
          <TextAreaField
            label='Descrição'
            name={meta.texto}
            maxLength={4000}
            rows={3}
            placeholder='Insira as impressões subjetivas do profissional e as expressadas pelo cidadão'
          />
        </HeadingSection>
      </>
    )
  }

  return <Form<MotivoConsultaFormModel> render={renderForm} {...props} />
}
